import React from 'react';
import { autobind } from 'core-decorators';
import List from '../../componentes/list';
import FaixaFarolEdit from './edit';
import ListColumn from '../../componentes/list/list-column';
import Slider from '../../componentes/slider';
import { injectIntl } from 'react-intl';
import ContentManager from '../../componentes/content-manager';
import ValidacaoRestricao from '../item/validacao-restricao';

@autobind
class FaixaFarolList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saved: false,
    };
  }

  handleDescricao(item) {
    return <span>{item.descricao}</span>;
  }

  handleMelhorMaior(item) {
    return (
      item.faixaMaior &&
      item.faixaMaior.length > 0 && (
        <Slider
          faixa={item.faixaMaior}
          colors={item.faixaMaior.map((c) => c.farol.cor)}
          values={item.faixaMaior.map((c) => c.valor)}
        ></Slider>
      )
    );
  }

  handleClose(saved) {
    if (saved) this.setState({ saved: !this.state.saved });
  }

  handleDeleteClick(item) {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/faixafarol/ValidarRestricoes"
        urlExclusao="/faixafarol/Remove"
        item={item}
        onClose={this.handleClose}
      />
    );
  }

  handleMelhorMenor(item) {
    return <Slider model={{ value: item.faixaMenor }} />;
  }

  handleMelhorIgual(item) {
    return <Slider model={{ value: item.faixaIgual }} />;
  }

  render() {
    const { intl } = this.props;

    return (
      <List
        url="/FaixaFarol"
        editComponent={FaixaFarolEdit}
        pageSize={20}
        tag={4003}
        onDeleting={this.handleDeleteClick}
        showSearch
        saved={this.state.saved}
        {...this.props}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'descricao' })}
          required
          valueFunction={this.handleDescricao}
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'idIntegracao' })}
          valueField="idIntegracao"
        />
      </List>
    );
  }
}

export default injectIntl(FaixaFarolList);
